import { useCreateMobileMoneyAccount } from "../../../../hooks/queries/useMerchantQueries";
import useModalManager from "./useModalManager";
import useAccountForm from "./useAccountForm";
import useMobileMoneyVerification from "./useMobileMoneyVerification";
import createAccountSubmitHandler from "../utils/accountSubmitHandler";

const useMobileMoneyHandlers = () => {
  const { modalState, openModal, closeModal } = useModalManager();
  const { mutate: createMobileMoneyAccount, isPending: mobileMoneyPending } =
    useCreateMobileMoneyAccount();
  const { control, handleSubmit, reset, setValue } = useAccountForm("mobile");
  const {
    handleBlur: handleMsisdnBlur,
    handleMsisdnChange,
    handleProviderChange,
    resetVerification,
    isVerifying,
    isVerified,
    isUnverified,
    message: verificationMessage,
  } = useMobileMoneyVerification({ setValue });

  const handleCloseModal = () => {
    closeModal("mobile");
    reset();
    resetVerification();
  };

  const onSubmit = createAccountSubmitHandler(
    createMobileMoneyAccount,
    (accountData) => accountData,
    () => {
      closeModal("mobile");
      reset();
      resetVerification();
    },
    "mobile",
  );

  return {
    modalOpened: modalState.mobile,
    openModal: () => openModal("mobile"),
    closeModal: handleCloseModal,
    handleSubmit: handleSubmit(onSubmit),
    control,
    isSubmitting: mobileMoneyPending,
    handleMsisdnBlur,
    handleMsisdnChange,
    handleProviderChange,
    isVerifying,
    isVerified,
    isUnverified,
    verificationMessage,
  };
};

export default useMobileMoneyHandlers;
